import { render, staticRenderFns } from "./AllServices.vue?vue&type=template&id=bf9965de&scoped=true&"
import script from "./AllServices.vue?vue&type=script&lang=js&"
export * from "./AllServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9965de",
  null
  
)

export default component.exports